// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1NNSo","containerItemsCenter":"Skeleton_containerItemsCenter__VKVNP"};